export const getIntegerFromString = (string: string): number => {
  return parseInt(string.replace(/\D/g, ''), 10);
};
